import { HStack, IconButton, Spinner, Text } from '@chakra-ui/react'
import type { FC } from 'react'
import { useCallback, useState } from 'react'

import { Tag } from '@app/components/ui/tag'
import Can from '@app/shared/authorization/can'
import type { MinimalDomainObject } from '@app/types'
import ICON_MAP from '@app/utils/iconMap'
import { useAiAssistantFileCacheFilesRemoveMutation } from '@graphql/queries'
import type { AiAssistantFile } from '@graphql/types'

const DeleteButton = ({ file }) => {
  const [, deleteFile] = useAiAssistantFileCacheFilesRemoveMutation()
  const [loading, setLoading] = useState(false)

  const onClick = useCallback(async () => {
    setLoading(true)
    try {
      await deleteFile({
        input: { cacheableId: file.cacheableId, cacheableType: file.cacheableType, fileIds: [file.id] }
      })
    } finally {
      setLoading(false)
    }
  }, [deleteFile, file.id, file.cacheableId, file.cacheableType])

  return (
    <IconButton
      _hover={{ color: 'red.500' }}
      aria-label={`Delete ${file.name}`}
      onClick={onClick}
      size="xs"
      variant="ghost"
    >
      {loading ? <Spinner size="xs" /> : <ICON_MAP.Delete />}
    </IconButton>
  )
}

type Props = {
  file: MinimalDomainObject<AiAssistantFile>
}

const File: FC<Props> = ({ file }) => (
  <Tag my={1} pr={0} colorPalette="gray">
    <HStack _hover={{ color: 'blue.500' }} transition="color 0.2s" pl={1}>
      <ICON_MAP.Upload />
      <Text pr={1}>{file.name}</Text>
      <Can I="delete" a="businessContext">
        <DeleteButton file={file} />
      </Can>
    </HStack>
  </Tag>
)

export default File
